export const controlVariants = {
    initial: {
        opacity: 0
    }, animate: (i) => ({
        opacity: 1,
        transition: {
            duration: 1,
            ease: "easeIn"
        }
    }), exit: (i)  => ({
        opacity: 0,
        transition: {
            duration: 1,
            ease: "easeOut"
        }
    })
}